import React from 'react';
import PrintProvider, { NoPrint } from 'react-easy-print';
import version from '../../revision.json';
import './Footer.css';

export const Footer = () => (
  <PrintProvider>
    <NoPrint force >
      <div id="version" >
        {version}
      </div>
    </NoPrint>
  </PrintProvider>
);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx